import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isModalOpen: false,
  modalViewParams: null,
  reload: false,
}

const slice = createSlice({
  name: 'dict',
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpen = true
    },
    closeModal(state) {
      state.isModalOpen = false
      state.modalViewParams = null
    },
    setModalViewParams(state, action) {
      state.modalViewParams = action.payload
    },
    setReload(state, action) {
      state.reload = action.payload
    },
  },
})

export const { openModal, closeModal, setModalViewParams, setReload } = slice.actions
export const reducer = slice.reducer
